import { useQuery } from "@tanstack/react-query";

import API from "@/api";

function useTankStats(nurseryId: string, tankId: string) {
  const { isPending, error, data } = useQuery({
    queryKey: ["tank-stats", nurseryId, tankId],
    queryFn: () => API.getTankStats(nurseryId, tankId)
  });

  return {
    isPending,
    error,
    data
  };
}

export default useTankStats;
